// (c) 2024 ABBYY Development, Inc.

import { FC, useEffect } from 'react';
import { Dialog, Typography } from 'components';
import { useTranslation } from 'react-i18next';
import {Container, Content} from './Styled';
import { useNotification } from 'libs/notification';
import { useAbout } from 'hooks';

interface AboutDialogProps {
    isOpen: boolean;
    close: () => void;
}

export const AboutDialog: FC<AboutDialogProps> = ({ isOpen, close }) => {
    const { t } = useTranslation();
    const { error } = useNotification();
    const { data, isError } = useAbout(isOpen);

    useEffect(() => {
        if (isError) {
            error(t('error.something_happened'));
        }
    });

    return (
        <Dialog width={550} height={430} isOpen={isOpen} onClose={close}>
            <Dialog.Header
                title={t('expressions.about_modal_title')}
                onClose={close}
            />
            <Dialog.Body>
                <Container>
                    <Content>
                        <Typography isParagraph>
                            {t('general.Version')}: {data.version}
                        </Typography>
                        <Typography isParagraph>
                            {t('general.ImageProcessingVersion')}: {data.imageProcessingVersion}
                        </Typography>
                        <Typography isParagraph>
                            {`© ${new Date().getFullYear()} ${t(
                                'expressions.legal_text'
                            )}`}
                        </Typography>
                    </Content>
                </Container>
            </Dialog.Body>
        </Dialog>
    );
};
